import React from "react";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
const BreadCrumb = ({ items }) => {
  return (
    <div className="breadcrumb-inner text-start p-0">
      <ul className="page-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={index}>
              <li
                className={`rbt-breadcrumb-item ${isLast ? "active" : ""}`}
              >
                {isLast || !item.path ? (
                  item.label
                ) : (
                  <Link to={item.path}>{item.label}</Link>
                )}
              </li>

              {!isLast && (
                <li>
                  <div className="icon-right">
                    <MdOutlineKeyboardArrowRight />
                  </div>
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default BreadCrumb;